module.exports = __webpack_public_path__ + "img/yfh-thumb4.2629221a.png";